const rolesPermissions = {
  admin: {
    canView: [
      // "Devis",
      "Paramètres",
      "sidebarUsers",
      "Liste Des Utilisateurs",
      "sidebarFormations",
      "sidebarAbonnements",
      "sidebarParametres",
      "news",
      "sidebarRequestSuppHours",
      "UserDetails",
      "Liste Des Devis",
      "Liste Des Demandes",
      "Tableau de bord",
      "Contacts",
      "Simulations",
      "Configurations",
      "Contacts Consultek"
    ],
    canEdit: [
      "Tableau de bord",

      "users",
      "Liste Des Utilisateurs",
      "apprenants",
      "formations",
      "abonnements",
      "news",
      "subscriptionType",
      "UserDetails",
      "Liste Des Devis",
      "Paramètres",
      "Liste Des Demandes",
    ],
  },
  client: {
    canView: ["sidebarDashboard", "Devis", "Paramètres", "Dashboard"],
    canEdit: ["apprenants", "PParamètres"],
  },
  gestionnaire: {
    canView: [
      "Liste Des Devis",
      // "Devis",
      // "Dashboard",
      "Paramètres",
      "sidebarApprenants",
      "sidebarUsers",
      "sidebarFormations",
      "sidebarAbonnements",
      "sidebarRequestSuppHours",
      "sidebarParametres",
      "Liste Des Demandes",
    ],
    canEdit: [
      "Liste Des Devis",
      // "Devis",

      "users",
      "Paramètres",
      "formations",
      "abonnements",
      "subscriptionType",
      "Paramètres",
      "Liste Des Demandes",
    ],
  },
};

export default rolesPermissions;
